import { detect } from "detect-browser/es";
export function isChrome() {
  if (detect().name === 'chrome') {
    return true;
  }
  return false;
}
export function isFirefox() {
  if (detect().name === 'firefox') {
    return true;
  }
  return false;
}
export function isIeEdge() {
  if (detect().name === 'ie') {
    return true;
  }
  if (detect().name === 'edge') {
    return true;
  }
  if (detect().name === 'edge-chromium') {
    return true;
  }
  return false;
}
export function isIe() {
  if (detect().name === 'ie') {
    return true;
  }
  return false;
}
export function isEdge() {
  if (detect().name === 'edge') {
    return true;
  }
  return false;
}
export function isSafari() {
  if (detect().name === 'safari') {
    return true;
  }
  return false;
}
export function getBrowser() {
  switch (detect().name) {
    case 'ie':
      return 'ie';
      break;
    case 'edge':
      return 'edge';
      break;
    case 'edge-chromium':
      return 'edge';
      break;
    case 'chrome':
      return 'chrome';
      break;
    case 'firefox':
      return 'firefox';
      break;
    case 'safari':
      return 'safari';
      break;
    default:
      return 'other';
  }
}
export function showBrowsers(browsers) {
  let display = false;
  if (getBrowser() === 'ie' && browsers.includes('ie')) {
    display = true;
  }
  if (getBrowser() === 'firefox' && browsers.includes('firefox')) {
    display = true;
  }
  if (getBrowser() === 'chrome' && browsers.includes('chrome')) {
    display = true;
  }
  if (getBrowser() === 'edge' && browsers.includes('edge')) {
    display = true;
  }
  if (getBrowser() === 'other' && browsers.includes('other')) {
    display = true;
  }
  return display;
}